<template>
  <div id="userForm" class="form">
    <v-card class="mt-2 pb-5" elevation="0">
      <v-card-title>{{ id ? "Edit User" : "Create User" }}
        <v-spacer />
        <v-btn icon @click="goBack"><v-icon>mdi-close</v-icon></v-btn>
      </v-card-title>


      <v-card-text>

        <v-tabs v-model="tabs">
          <v-tabs-slider></v-tabs-slider>
          <v-tab href="#tabs-1" class="primary--text">
            Details
          </v-tab>

          <v-tab v-if="user.id" href="#tabs-2" class="primary--text">
            Accessible Modules
          </v-tab>

          <v-tab v-if="user.id" href="#tabs-3" class="primary--text">
            User Roles
          </v-tab>

          <v-tab v-if="user.id" href="#tabs-4" class="primary--text">
            Authorized Locations
          </v-tab>

        </v-tabs>

        <v-tabs-items v-model="tabs">
          <v-tab-item value="tabs-1">

            <v-card class="mt-5" elevation="0">


              <v-card-text class="pb-0">
                <p class="text-h6">User Details</p>
              </v-card-text>

              <v-card-text>
                <v-form v-if="loaded" ref="form" v-model="valid" lazy-validation>

                  <v-row>
                    <v-col cols="12" md="6"> <v-text-field v-model="user.firstName" label="First Name" :required="true"
                        outlined /></v-col>
                    <v-col cols="12" md="6"><v-text-field v-model="user.lastName" label="Last Name" :required="true"
                        outlined /></v-col>
                  </v-row>

                  <v-row>
                    <v-col cols="12" md="6"><v-text-field v-model="user.username" label="User Name" :required="true"
                        outlined /></v-col>
                    <v-col cols="12" md="6"> <v-text-field v-model="user.email" label="Email" :required="true"
                        outlined /></v-col>
                  </v-row>

                  <v-row>
                    <v-col cols="12" md="6"> <v-text-field v-model="user.phone" label="Phone" :required="true"
                        outlined /></v-col>
                  </v-row>

                  <v-sheet class="d-md-flex">

                    <v-sheet class="flex-column">

                    </v-sheet>


                    <v-spacer></v-spacer>

                    <v-sheet class="justify-right text-right">

                      <v-btn @click="goBack" plain class="mr-4">Back </v-btn>

                      <v-btn @click="handleSubmit" color="primary" rounded x-large>
                        {{ id ? "Update" : "Save" }}
                      </v-btn>
                    </v-sheet>

                  </v-sheet>

                </v-form>
              </v-card-text>
            </v-card>

          </v-tab-item>

          <v-tab-item value="tabs-2">
            <v-card v-if="user.id" class="mt-5" elevation="0">
              <v-card-text class="pb-0">
                <p class="text-h6"> Accessible Modules</p>
              </v-card-text>

              <v-card-text>
                <v-select outlined v-model="userModules" label="User's module" multiple chips :items="availableModules"
                  item-text="name" item-value="id" />
              </v-card-text>
              <v-card-actions class="text-right">
                <v-spacer />
                <v-btn rounded x-large color="primary" @click="updateUserModules" :loading="isAppLoading"
                  :disabled="isAppLoading">
                  Update
                </v-btn>

                <v-spacer />
              </v-card-actions>
            </v-card>
          </v-tab-item>

          <v-tab-item value="tabs-3">
            <v-card v-if="user.id" class="mt-5" elevation="0">
              <v-card-text class="pb-0">
                <p class="text-h6">User Roles</p>
              </v-card-text>

              <v-card-text>
                <v-select v-model="userRoles" outlined label="User roles" multiple chips :items="groupedRoles"
                  item-text="name" item-value="id" />
              </v-card-text>
              <v-card-actions>
                <v-spacer />

                <v-btn rounded x-large color="primary" @click="updateUserRoles" :loading="isAppLoading"
                  :disabled="isAppLoading">
                  Update
                </v-btn>
                <v-spacer />
              </v-card-actions>
            </v-card>
          </v-tab-item>

          <v-tab-item value="tabs-4">
            <v-card v-if="user.id" class="mt-5" elevation="0">
              <v-card-text class="pb-0">
                <p class="text-h6">Authorized Locations</p>
              </v-card-text>
              <v-card-text>
                <v-select v-model="userLocations" outlined multiple chips label="Authorized Locations"
                  :items="availableLocations" item-text="name" item-value="id" />
              </v-card-text>
              <v-card-actions>
                <v-spacer />
                <v-btn rounded x-large color="primary" @click="updateUserLocations" :loading="isAppLoading"
                  :disabled="isAppLoading">
                  Update
                </v-btn>
                <v-spacer />
              </v-card-actions>
            </v-card>
          </v-tab-item>

        </v-tabs-items>

      </v-card-text>

    </v-card>

  </div>
</template>

<script>
import { getUser } from "@/services/user";
import { mapActions, mapGetters } from "vuex";
import { getAccountModules } from "@/services/module";
import {
  getAccountRoles,
} from "@/services/accountServices.js";

export default {
  props: ["id", "isModal"],
  data() {
    return {
      loaded: false,
      valid: false,
      user: {
        relations: {},
        firstName: "",
        lastName: "",
        username: "",
        phone: "",
        email: "",
      },
      userModules: [],
      availableModules: [],
      userRoles: [],
      availableRoles: [],
      userLocations: [],
      availableLocations: [],
      account: null,
      editPassword: false,
      tabs: null,
    };
  },
  created() {
    this.setInstace();
  },
  computed: {
    ...mapGetters("navigation", ["navState", "isAppLoading", "globalCenter"]),
    groupedRoles() {
      if (this.availableRoles) {
        //filter roles selected by user's modules
        const filteredRoles = this.availableRoles.filter(r => r.moduleId == null || this.userModules.includes(r.moduleId));
        const clone = [...filteredRoles];
        clone.sort((r1, r2) => r1.moduleName > r2.moduleName ? 1 : -1);
        const results = [];
        let cursor = null;
        clone.forEach((r) => {
          if (!cursor || cursor != r.moduleName) {
            results.push({ header: r.moduleName });
            cursor = r.moduleName;
          }
          results.push(r)
        })
        return results;
      } else {
        return [];
      }
    },
  },
  methods: {
    ...mapActions("user", ["createUser", "updateUser"]),
    ...mapActions("messages", [
      "addMessage",
      "addErrorMessage",
      "addSuccessMessage",
    ]),

    async handleSubmit() {
      if (this.id) {
        let user = this.user;
        delete user.relations;

        this.updateUser(user)
          .then((response) => {
            console.log(response);
            this.addSuccessMessage("User was updated successfully");
            // this.edit(user);
            this.goBack();

          })
          .catch(() => {
            this.addErrorMessage("Error updating User, please try again later");
          });
      } else {
        let user = this.user;
        delete user.relations;

        this.createUser(user)
          .then((response) => {
            console.log(response);
            this.addSuccessMessage("User was created successfully");
            // this.edit(savedUser);
            this.goBack();
          })
          .catch(() => {
            this.addErrorMessage("Error creating User, please try again later");
          });
      }
    },
    goBack() {
      if (this.isModal) {
        this.onCloseDialog();
      }
      else {
        this.$router.go(-1);
      }
    },
    edit(item) {
      this.$router.push({ name: "userEdit", params: { id: item.id } });
    },
    setInstace() {
      if (this.id) {
        this.user.id = this.id;

        if(this.id){
          getUser(this.id).then((response) => {
            let instance = response.data;
            for (let property in instance) {
              if (
                Object.prototype.hasOwnProperty.call(instance, property) &&
                Object.prototype.hasOwnProperty.call(this.user, property)
              ) {
                this.user[property] = instance[property];
              }
            }
            this.loaded = true;
          });
        }
      } else {
        this.loaded = true;
      }
      this.setDependencies();
    },
    async setDependencies() {
      this.initAccount().then((account) => {
        this.account = account;
      });

      await getAccountModules().then((resp) => {
        this.availableModules = resp.data.content;
        this.loadUserModules();
      });

      this.loadAccountRoles().then(() => {
        this.loadUserRoles();
      });

      this.loadAccountLocations().then((allLocations) => {
        console.log(allLocations);
        this.loadUserLocations();
      });
    },
    async initAccount() {
      return await this.$axios
        .get("/account/get-by-id", {
          params: { accountId: this.globalCenter.accountId },
        })
        .then((resp) => {
          return resp.data;
        })
        .catch(() => {
          this.addErrorMessage("Error loading account from server");
        });
    },
    loadUserModules() {
      this.$axios("/user/module", { params: { user_id: this.user.id } }).then(
        (resp) => {
          const userMods = resp.data;
          if (userMods) {
            this.userModules = userMods.map((m) => m.id);
          }
        }
      );
    },
    loadUserRoles() {
      this.$axios("/user/roles", { params: { user_id: this.user.id } }).then(
        (resp) => {
          const userRoles = resp.data;
          if (userRoles) {
            this.userRoles = userRoles.map((m) => m.id);
          }
        }
      );
    },
    loadUserLocations() {
      this.$axios("/user/locations", {
        params: { user_id: this.user.id },
      }).then((resp) => {
        const userLocations = resp.data;
        if (userLocations) {
          this.userLocations = userLocations.map((m) => m.id);
        }
      });
    },
    async loadAccountLocations() {
      return await this.$axios("/account/get-locations").then((resp) => {
        this.availableLocations = resp.data;
        return this.availableLocations;
      });
    },
    async loadAccountRoles() {
      this.availableRoles = await getAccountRoles();

      if (this.availableModules) {
        this.availableRoles.sort((r1, r2) => r1.name > r2.name ? -1 : 1);
        this.availableRoles.forEach((r) => {
          const module = this.availableModules.find(
            (m) => m.id == r.moduleId
          );
          r.moduleName = module ? module.name : "All Modules";
        });
      }
      return this.availableRoles;
    },
    updateUserModules() {
      console.log("updating user module...");
      const data = {
        userId: this.user.id,
        moduleIds: this.userModules ? this.userModules : [],
      };
      this.$axios.post("/user/module", data).then(() => {
        this.addSuccessMessage("User modules updated");
      });
    },
    updateUserRoles() {
      console.log("updating user roles...");
      const data = {
        userId: this.user.id,
        roleIds: this.userRoles ? this.userRoles : [],
      };
      this.$axios.post("/user/role", data).then(() => {
        this.addSuccessMessage("User roles updated");
      });
    },
    updateUserLocations() {
      console.log("updating user locations...");
      const data = {
        userId: this.user.id,
        locationIds: this.userLocations ? this.userLocations : [],
      };
      this.$axios.post("/user/location", data).then(() => {
        this.addSuccessMessage("User location updated");
      });
    },
    onCloseDialog() {
      this.id = null;
      this.$emit('closeUserDialog')
    },
  },
  components: {},
};
</script>
